import {
	Component,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges
} from '@angular/core';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Vacation } from 'src/app/shared/models/vacation';

@Component({
	selector: 'app-vacation-report',
	templateUrl: './vacation-report.component.html',
	styleUrls: ['./vacation-report.component.scss']
})
export class VacationReportComponent implements OnChanges {
	@Input() employees: Employee[];

	uniqueVacationTypes: string[] = [];

	constructor() {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.employees) {
			this.calculateVacations();
			this.updateUniqueVacationTypes();
		}
	}

	private updateUniqueVacationTypes(): void {
		const allTypes = new Set<string>();
		this.employees?.forEach((employee) => {
			employee.vacations.forEach((vacation) => {
				allTypes.add(vacation.vacationType.type);
			});
		});
		this.uniqueVacationTypes = Array.from(allTypes);
	}

	private calculateVacations(): void {
		const now = new Date();
		const currentYear = now.getFullYear();
		const startOfYear = new Date(currentYear, 0, 1);

		this.employees?.forEach((employee) => {
			const counts: { [type: string]: number } = {};
			let totalDaysTaken = 0;

			// Calculer le nombre de jours de congé accumulés
			const monthsWorked =
				(now.getFullYear() - new Date(startOfYear).getFullYear()) * 12 +
				now.getMonth() -
				new Date(startOfYear).getMonth();
			employee.totalVacationDaysEntitled = monthsWorked * 2.5;

			employee.vacations.forEach((vacation) => {
				if (vacation.vacationType.type === 'Congés') {
					const daysTaken = this.calculateVacationDays(vacation);
					totalDaysTaken += daysTaken;

					const type = vacation.vacationType.type;
					counts[type] = (counts[type] || 0) + daysTaken;
				}
			});

			employee.totalVacationDaysTaken = totalDaysTaken;
		});
	}

	private calculateVacationDays(vacation: Vacation): number {
		let totalDays = 0;
		const startDate = new Date(vacation.startDate);
		const endDate = new Date(vacation.endDate);

		while (startDate <= endDate) {
			const dayOfWeek = startDate.getDay();
			if (dayOfWeek !== 6 && dayOfWeek !== 0) {
				// Ignorer samedi et dimanche
				totalDays++;
			}
			startDate.setDate(startDate.getDate() + 1);
		}

		return totalDays;
	}
}
